import { TFeaturedComponent } from "src/Featuresmap";
import { BaseForm, TFormType } from "./BaseForm";

type TIntegrationsProps = {
	target_id: any;
	target_type: TFormType;
};

export const Integrations: TFeaturedComponent<TIntegrationsProps> = ({ target_id, target_type }) => {
	return <BaseForm target_id={target_id} target_type={target_type} type="integration" />;
};

Integrations.feature = "integrations";
